import {QUESTION_STATUS} from "../conf/sirating";
import {getLastElementOr} from "./array-utils";

export const getQuestionStatus = (id, defaultStatus = QUESTION_STATUS.virgin ) => (
    Object.keys(QUESTION_STATUS)
        .map( status =>  QUESTION_STATUS[ status ] )
        .filter( qs => qs.id === id )
        .reduce( getLastElementOr, defaultStatus )
);
